import { ITemplatesInitialState } from "../Interfaces/ITemplates";

export const TemplatesInitialState: ITemplatesInitialState = {
    isLoadingTemplatesDashboard: false,
    templates: []
}